import { WebGLRenderTarget, HalfFloatType, RGBAFormat, LinearFilter, NearestFilter } from 'three';

export function createGBuffer(width: number, height: number): WebGLRenderTarget {
  const target = new WebGLRenderTarget(width, height, {
    count: 2,
    type: HalfFloatType,
    format: RGBAFormat,
    depthBuffer: true,
    samples: 0,
  });

  target.textures[0]!.minFilter = LinearFilter;
  target.textures[0]!.magFilter = LinearFilter;
  target.textures[1]!.minFilter = NearestFilter;
  target.textures[1]!.magFilter = NearestFilter;

  return target;
}

export function createPaintRT(width: number, height: number): WebGLRenderTarget {
  return new WebGLRenderTarget(width, height, {
    type: HalfFloatType,
    format: RGBAFormat,
    depthBuffer: false,
    samples: 0,
    minFilter: LinearFilter,
    magFilter: LinearFilter,
  });
}
